export function extractHeadersFromAxiosResponse(response) {
    const headers = [];
    for (const headerKey of Object.keys(response.headers)) {
        headers.push({
            header: headerKey,
            value: response.headers[headerKey]
        });
    }
    return headers;
}
//# sourceMappingURL=headers-helper.js.map